import { Component, Input, Output, EventEmitter, inject, Inject } from '@angular/core';
import { Api } from '../../services/api';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert.service';
import { PermissionService } from '../../services/permission.service';

@Component({
    standalone: true,
  selector: 'app-mdl-change-budget',
  imports: [FormsModule,NgSelectModule,CommonModule,MatDialogModule],
  templateUrl: './mdl-change-budget.html',
  styleUrls: ['./mdl-change-budget.css']
})
export class MdlChangeBudgetComponent {
  users: any[] = [];
  selectedOwner: string = '';
  sendEmail: boolean = false;

  public budgetData: any;
   @Output() ownerChanged = new EventEmitter<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mdl: MatDialogRef<MdlChangeBudgetComponent>,
    private api: Api,
    private alertService: AlertService,
    public permissionService:PermissionService
    
  ) {
    console.log('Datos recibidos en el modal:', data);
       this.budgetData = data.budgetData;
       console.log('budgetData completo en modal:', this.budgetData);
       console.log('presupuesto ID:', this.budgetData.presupuesto_id);


    this.api.getUsers().subscribe({
      next: (res: any) => {
        console.log('Respuesta de getUsers:', res.users);
        this.users = res.users || [];

        this.users = (res.users || []).map((user: any) => ({
          ...user,
          nombreCompleto: `${user.nombre} ${user.apellido}`,
        }),);

        for (let i = 0; i < this.users.length; i++) {
          if(this.users[i].usuario_id === this.budgetData.ejecutivo_id){
            this.selectedOwner = this.users[i].usuario_id;
          }
        }
      },
      error: (err) => {
        console.log('Error al cargar usuarios:', err);
        this.users = [];
      }
    });
  }

  get nombreCompletoseleccionado(): string {
    const user = this.users.find(u => u.usuario_id === this.budgetData.ejecutivo_id);
    return user ? `${user.nombre} ${user.apellido}` : '';
  }

  saveChange(): void {
    console.log('Selected Owner:', this.selectedOwner);
    console.log('presupuesto ID:', this.budgetData?.presupuesto_id);

    if (!this.selectedOwner || !this.budgetData?.presupuesto_id) {
      console.warn('Datos incompletos para guardar cambio de propietario');
      return;
    }

    const payload = {
      presupuesto_id: this.budgetData.presupuesto_id,
      newOwner: this.selectedOwner,
      notifyByEmail: this.sendEmail || false
    };
    console.log('Payload enviado:', payload);

    this.api.changeBudgetOwner(payload).subscribe({
      next: (res) => {
        console.log('Respuesta cambio propietario:', res);
        window.alert('Propietario cambiado exitosamente');
        this.ownerChanged.emit(res);
        this.mdl.close(res);
      },
      error: (err) => {
        console.error('Error cambio propietario:', err);
        window.alert('Hubo un error al cambiar el propietario');
        this.mdl.close();
      }
    });
  }

  closeMdl(): void {
    this.mdl.close();
  }
}
